import { Link } from 'react-router-dom';
import { channels } from '@/mocks/channels';
import SectionHeading from '@/components/feature/SectionHeading';

const tintStyles: Record<string, { wrap: string; icon: string; hover: string }> = {
  primary: {
    wrap: 'border-primary-200/70 bg-primary-50/60',
    icon: 'bg-primary-100 text-primary-700',
    hover: 'group-hover:border-primary-400',
  },
  accent: {
    wrap: 'border-accent-200/70 bg-accent-50/70',
    icon: 'bg-accent-100 text-accent-700',
    hover: 'group-hover:border-accent-400',
  },
  secondary: {
    wrap: 'border-secondary-200/70 bg-secondary-50/70',
    icon: 'bg-secondary-100 text-secondary-800',
    hover: 'group-hover:border-secondary-400',
  },
};

export default function ChannelGrid() {
  return (
    <section className="bg-background-100/80 py-14 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          eyebrow="CHANNELS"
          title="六个专栏，专治不同场合的无聊"
          desc="饭点、通勤、加班、睡前，每个场景都能在这里找到刚好对味的那一类内容。"
          action={
            <Link
              to="/channel/regua"
              className="hidden whitespace-nowrap rounded-md border border-foreground-200 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 md:inline-flex"
            >
              浏览全部专栏
            </Link>
          }
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((channel) => {
            const style = tintStyles[channel.tint] ?? tintStyles.primary;
            return (
              <Link
                key={channel.slug}
                to={`/channel/${channel.slug}`}
                className={`group flex flex-col rounded-2xl border p-5 transition-colors md:p-6 ${style.wrap} ${style.hover}`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-xl ${style.icon}`}
                  >
                    <i className={`${channel.icon} w-6 h-6 flex items-center justify-center text-2xl`} />
                  </span>
                  <span className="rounded-full bg-background-50/80 px-3 py-1 text-xs text-foreground-600">
                    {channel.count} 条
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg text-foreground-950">
                  {channel.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {channel.desc}
                </p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                  进入专栏
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}